<template>
  <div>
    <multi-select @input="selectOption"
                  :value="selectedValue"
                  :options="options"
                  label="label"
                  track-by="value"
                  :searchable="false"
                  :allow-empty="false"
                  :show-labels="false"
                  class="text-input dropdown"
                  :class="{'is-invalid': invalid}"></multi-select>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect';

export default {
  name: "GenderDropdown",

  props: ['value', 'invalid'],

  data() {
    return {
      options: [
        {value: 'M', label: 'Male'},
        {value: 'F', label: 'Female'},
      ],
    };
  },

  computed: {
    selectedValue() {
      return this.options.find(item => item.value === this.value);
    },
  },

  components: {MultiSelect},

  methods: {
    selectOption(event) {
      this.$emit('input', event.value);

      this.$store.commit('userSelections/clearFitPreferences');
    },
  },
};
</script>
